import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { PAReviewMeetingActionItemModel } from "@/store/models/paReview/paReviewMeetingActionItem";
import { cloneDeep } from "lodash";
let ReviewMeetingActionItemUpsert = /** @class */ (() => {
    var _a;
    let ReviewMeetingActionItemUpsert = class ReviewMeetingActionItemUpsert extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.actionItem = new PAReviewMeetingActionItemModel();
        }
        saveActionItem() {
            this.validate("actionItemObserver").then((response) => {
                if (response) {
                    this.actionItem.dueDateAsString = this.getFormattedDateString(this.actionItem.dueDate);
                    this.$emit("save", this.actionItem);
                }
            });
        }
        getFormattedDateString(value) {
            return `${value.getFullYear()}-${value.getMonth() + 1}-${value.getDate()}T00:00:00`;
        }
        cancel() {
            this.$emit("cancel-action");
        }
        disabledAfterToday(date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return date < new Date(today.getTime());
        }
        created() {
            this.action.dueDate != null ? (this.action.dueDate = new Date(this.action.dueDate)) : null;
            this.actionItem = cloneDeep(this.action);
        }
        destroyed() {
            this.actionItem = null;
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof PAReviewMeetingActionItemModel !== "undefined" && PAReviewMeetingActionItemModel) === "function" ? _a : Object)
    ], ReviewMeetingActionItemUpsert.prototype, "action", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], ReviewMeetingActionItemUpsert.prototype, "participants", void 0);
    ReviewMeetingActionItemUpsert = __decorate([
        Component({
            name: "ReviewMeetingActionItemUpsert",
            components: {
                Loader,
            },
        })
    ], ReviewMeetingActionItemUpsert);
    return ReviewMeetingActionItemUpsert;
})();
export default ReviewMeetingActionItemUpsert;
